import { Injectable } from '@angular/core';
import { Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { Routes } from '../constants';

@Injectable()
export class LatestPolicyGuard  {

  constructor(private authService: AuthenticationService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    if (this.authService.IsAuthenticated() && this.authService.GetLoggedInUserDetails().type.toLocaleLowerCase() === 'external') {
      if (!this.authService.GetUserPolicyAcceptanceDetails().isTermsOfUseRead) {
        if (state.url.includes(Routes.TERMS_OF_USE_ROUTE)) {
          return true;
        }
        this.router.navigate([Routes.TERMS_OF_USE_ROUTE]);
        return;
      }
      if (!this.authService.GetUserPolicyAcceptanceDetails().isPrivacyPolicyRead) {
          if (state.url.includes(Routes.PRIVACY_POLICY_ROUTE)) {
            return true;
          }
          this.router.navigate([Routes.PRIVACY_POLICY_ROUTE]);
          return;
        }
    }
    return true;
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.IsAuthenticated() && this.authService.GetLoggedInUserDetails().type.toLocaleLowerCase() === 'external') {
      if (!this.authService.GetUserPolicyAcceptanceDetails().isTermsOfUseRead) {
        this.router.navigate([Routes.TERMS_OF_USE_ROUTE]);
        return;
      }
      if (!this.authService.GetUserPolicyAcceptanceDetails().isPrivacyPolicyRead) {
        this.router.navigate([Routes.PRIVACY_POLICY_ROUTE]);
        return;
      }
    }
    return true;
  }
}
